module.exports = __webpack_public_path__ + "img/trip(2).3c4cf5d1.webp";